import { useCallback, useEffect, useState } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";
import { normalizeQualificationMode } from "../utils/loyaltyQualification";

export function useLoyaltySettings(brandName) {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        if (!brandName) {
            setSettings(null);
            return null;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await loyaltyFetch(`${LOYALTY_API_BASE}/admin/loyalty-settings`, {
                headers: { "X-Brand": brandName },
            });
            if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
            const data = await res.json();
            setSettings(data);
            return data;
        } catch (err) {
            setError(err.message);
            setSettings(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, [brandName]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return {
        settings,
        loading,
        error,
        refetch,
        qualificationMode: normalizeQualificationMode(settings?.qualification_mode),
    };
}
